// src/config/noticias.js
// Configuraciones específicas para el módulo de noticias
import noticiaPlaceholder from '../assets/noticia-placeholder.jpg'

export const TIPO_NOTICIA_NORMAL = 'normal'
export const NOTICIAS_NO_IMAGE = noticiaPlaceholder
export const NOTICIAS_FETCH_CUANTOS = 10